import { FC, useContext } from 'react';

import { ARCHETYPE_WITH_IMAGE, ARCHETYPE_WITHOUT_IMAGE } from '../../../../constants/constants';
import BusinessUnitParamsContext from '../../../../contexts/BusinessUnitParamsContext/businessUnitParamsContext';
import CardHirePlanMobile from '../CardHirePlanMobile';
import CardHirePlanMobileWithImage from '../CardHirePlanMobileWithImage';

type Props = {
  infoToContract: any;
  businessPlanName: string;
};
const CardHirePlanMobileWithArcheType: FC<Props> = ({ infoToContract, businessPlanName }) => {
  const { portalArchetypeId } = useContext(BusinessUnitParamsContext);

  const getCardHireComponent = () => {
    switch (portalArchetypeId) {
      case ARCHETYPE_WITHOUT_IMAGE:
        return (
          <CardHirePlanMobile infoToContract={infoToContract} businessPlanName={businessPlanName} />
        );
      case ARCHETYPE_WITH_IMAGE:
        return (
          <CardHirePlanMobileWithImage
            infoToContract={infoToContract}
            businessPlanName={businessPlanName}
          />
        );
      default:
        return (
          <CardHirePlanMobile infoToContract={infoToContract} businessPlanName={businessPlanName} />
        );
    }
  };

  return getCardHireComponent();
};

export default CardHirePlanMobileWithArcheType;
